<template>
  <div class="boardTopFixStyle"
       @click="boardDetailMove(boardId, data.oBoard.nBoardNum, data.oBoard.oAuthorizeAccessRead )">
    <div :class="data.oBoard.strAtclType === 'NOTICE' ? 'notice' : '' ">
      <!-- 게시글 제목 -->
      <a>
        <span :class="{ bUserBlockY: !data.oBoard.oAuthorizeAccessRead.bAuthorizeAccess }">{{
            data.oBoard.strBoardTitle
          }}</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'boardTopFixStyle',
  data() {
    return {
      boardId: this.storageGet('vuex', 'boardActiveCode'),
    }
  },
  props: ['data'],
  // 계산된 속성
  computed: {},
  // 감시자
  watch: {},
  // $el 생성전
  created() {
  },
  // $el 생성후
  mounted() {
  },
  methods: {},
}
</script>
<style scoped>


</style>
